import React from "react";
import arrow from "../../assets/images/homePage/home_right_arrow.png";
import latest_1 from "../../assets/images/homePage/latest_news_1.png";
import latest_2 from "../../assets/images/homePage/latest_news_2.png";
import latest_3 from "../../assets/images/homePage/latest_news_3.png";
import useTranslation from "../../Languages/Translation";

const LatestNews = () => {
  const news = [
    {
      image: latest_1,
      title: "U.S. stock market capitalization",
      desc: "Financial markets are, in essence, one giant information processing machine.",
    },
    {
      image: latest_2,
      title: "Nulla eleifend ultricies tellus, cursus suscipit",
      desc: "Suspendisse finibus urna vitae urna suscipit, eget hendrerit lectus molestie.",
    },
    {
      image: latest_3,
      title: "Suspendisse finibus urna vitae urna suscipit",
      desc: "Praesent lacus nunc, elementum egestas Maecenas dapibus mi id orci dapibus cursus.",
    },
  ];

  const translation = useTranslation();

  return (
    <div>
      <div className=" main_container py-[30px] md:py-[80px]">
        <div className="flex items-center justify-between">
          <p className="text-[24px] md:text-[32px] leading-[40px] text-white aeonik_medium ">
            {translation.LatestNews}
          </p>
          <a
            href=""
            className="flex items-center md:text-[18px] leading-[27px] text-white aeonik_medium"
          >
            <span className="mr-[4px]">{translation.SeeAll}</span>
            <img src={arrow} alt="arrow" className="h-[20px] w-auto object-contain " />
          </a>
        </div>
        <div className="grid grid-cols-12 gap-x-[15px] lg:gap-x-[32px] mt-[32px]">
          {news.map((m, i) => (
            <div
              className="col-span-12 md:col-span-6 mb-5 lg:mb-0 lg:col-span-4 flex flex-col rounded-[24px] overflow-hidden"
              key={i}
            >
              <img src={m.image} alt="test" className="h-full w-full object-contain" />
              <div className="bg-white px-[32px] pt-[24px] pb-[32px]">
                <p className="text-[24px] leading-[30px] text-black aeonik_medium">
                  {m.title}
                </p>
                <p className="text-[18px] leading-[27px] text-black aeonik_normal mt-[8px]">
                  {m.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
